

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _checkout = require('xo-models/src/checkout');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _index = require('xo-return-to-merchant/dist/index');

require('./styles');

var _logger = require('xo-beaver/dist/logger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoGamblingBlockCoolOffPeriodPageComponent', {
    tag: 'xo-gambling-block-cool-off-period-page',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        }
    },
    actions: {
        redirectToCancelUrl: function redirectToCancelUrl() {
            var cancelUrl = this.models.checkoutAppData.urls.cancel_url;
            _index.$ReturnToMerchant.goTo(cancelUrl);
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            // on reload the header and the footer reappear, hence adding the timeout 
            (0, _angular.$timeout)(function () {
                $('.row-fluid.paypalHeaderWrapper').hide();
                $('.footer').hide();
            }, 0);
            this.token = _angular.$rootScope.token;
        },
        populate: function populate() {
            // to check if the merchant has a cancel_url present, if present the "return to merchant" button is displayed
            this.cancelUrlPresent = this.models.checkoutAppData.urls.cancel_url;
            _logger.$logger.info('checkout_fpti', {
                from: 'uk_gambling_block',
                to: 'uk_gambling_block_cool_down_page_loaded',
                context_id: _angular.$rootScope.token,
                context_type: 'EC-Token'
            });
        }
    }
});


_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_checkout.$CheckoutAppDataModel;

_index.$ReturnToMerchant;

_angular.$timeout;

_logger.$logger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-gambling-block-cool-off-period/directive.js
// module id = ./pages/xo-gambling-block-cool-off-period/directive.js
// module chunks = 0